import types from "../types"

const initial = {
	data: [],
}

export const notification_reducer = (state = initial, { type, payload }) => {
	switch (type) {
		case types.NOTIFICATION:
      return{
        data:payload
      }
		default:
			return state
	}
}